import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 4,
        rowsSize: [3, 1, 3, 1],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/03/20/principle/equalized-sample-1.svg`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/03/20/principle/equalized-sample-2.svg`,
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    url: `${config.ASSETS_URL}/03/20/principle/equalized-sample-1.wav`,
                    text: "Sound sample",
                    shape: "round",
                    icon: "cis-volume-high",
                    theme: "secondary",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    url: `${config.ASSETS_URL}/03/20/principle/equalized-sample-2.wav`,
                    text: "Sound sample",
                    shape: "round",
                    icon: "cis-volume-high",
                    theme: "secondary",
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/03/20/principle/equalized-sample-3.svg`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/03/20/principle/equalized-sample-4.svg`,
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    url: `${config.ASSETS_URL}/03/20/principle/equalized-sample-3.wav`,
                    text: "Sound sample",
                    shape: "round",
                    icon: "cis-volume-high",
                    theme: "secondary",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    url: `${config.ASSETS_URL}/03/20/principle/equalized-sample-4.wav`,
                    text: "Sound sample",
                    shape: "round",
                    icon: "cis-volume-high",
                    theme: "secondary",
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
